// Analytics utility for A/B testing homepage variants
// Search for "HOMEPAGE_CTA_CLICK" in logs to find all get-started clicks

import { hasConsent } from './cookieConsent';

const STORAGE_KEY = 'homepage_variant';

// Set the homepage variant (called when RandomHomePage makes its selection)
export const setHomepageVariant = (variant) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, variant);
  } catch (e) {
    // sessionStorage not available
  }
};

// Get the current homepage variant
export const getHomepageVariant = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || 'unknown';
  } catch (e) {
    return 'unknown';
  }
};

// Get or create a session ID for tracking
const getSessionId = () => {
  try {
    let sessionId = sessionStorage.getItem('analytics_session_id');
    if (!sessionId) {
      sessionId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('analytics_session_id', sessionId);
    }
    return sessionId;
  } catch (e) {
    return null;
  }
};

// Track a get-started click
// Search for "HOMEPAGE_CTA_CLICK" to find these in logs
export const trackGetStartedClick = (source, variant = null) => {
  if (!hasConsent('analytics')) return;
  const homepageVariant = variant || getHomepageVariant();
  const timestamp = new Date().toISOString();

  // Log format: HOMEPAGE_CTA_CLICK | variant | source | timestamp
  // This format is easy to grep/search in logs
  console.log(`HOMEPAGE_CTA_CLICK | variant=${homepageVariant} | source=${source} | time=${timestamp}`);

  // Also store in sessionStorage for potential analytics pickup
  try {
    const clicks = JSON.parse(sessionStorage.getItem('cta_clicks') || '[]');
    clicks.push({
      variant: homepageVariant,
      source,
      timestamp
    });
    sessionStorage.setItem('cta_clicks', JSON.stringify(clicks));
  } catch (e) {
    // sessionStorage not available
  }

  // Send to BFF for persistent tracking (fire-and-forget, don't block navigation)
  fetch('/api/analytics/track', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      eventType: 'homepage_cta_click',
      variant: homepageVariant,
      source,
      sessionId: getSessionId()
    })
  }).catch(() => {
    // Silently fail - tracking shouldn't block user experience
  });
};
